<template>
	<el-dialog
			    title="添加分组"
			    :visible.sync="dialogVisibe"
			    width="400px"
			    :custom-class="classNames + '_dialog'"
			    key="cardDialog"
				:close-on-press-escape="false"
				:close-on-click-modal="false"
			    @close="groupBtnCancel">
			        <div class="card-control-form">
						<el-form :model="groupInfo" :rules="rules" ref="ruleForm" label-position="right" label-width="0">
							<el-form-item label="" prop="name">
							    <el-input v-model="groupInfo.name" placeholder="请输入分组名称" maxlength="20"></el-input>
							</el-form-item>
						 </el-form>
					</div>
			        <span slot="footer" class="dialog-footer">
			            <el-button @click="groupBtnCancel()">取 消</el-button>
			            <el-button type="primary" @click="groupBtnSure()">确 定</el-button>
			        </span>
			</el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
export default {
	props: {
		value: {
		    type: Boolean,
		    default: false
		},
		groupInfo: {
		    type: Object,
			default: () => ({name: '',id: ''})
		},
	},
	data() {
		return {
			showFlag: true,
            classNames: "cardDialog",
			rules: {
			    name: [
			        {
			            required: true,
			            message: "分组名称不能为空",
			            trigger: "blur",
			        }
			    ]
			}
		}
	},
	computed: {
		dialogVisibe: {
			get() {
				return this.value
			},
			set(news) {
				this.$emit("input",news);
			}
		}
	},
	methods: {
		...mapActions('dymessage', ['groupAdd','groupEdit']),
		async groupBtnSure(){
			this.$refs.ruleForm.validate(async (valid) => {
				if(valid) {
					try {
						if(this.groupInfo.id){
							await this.groupEdit({name: this.groupInfo.name,id: this.groupInfo.id})
						} else {
							await this.groupAdd({name: this.groupInfo.name})
						}
						this.resetGroupInfo()
						this.$emit('groupList')
					} catch (error) {
						this.$message({
						    type: 'error',
						    message:'操作失败',
						    duration: 3000
						})
					}
				}
			})
		},
		groupBtnCancel(){
			this.resetGroupInfo()
		},
		resetGroupInfo(){
			this.groupInfo.name = ''
			this.groupInfo.id = ''
			this.groupInfo.sort = ''
			this.dialogVisibe = false
		}
	}
}
</script>
<style lang="less">
    .cardDialog_dialog {
        .el-dialog__body {
            padding: 12px 20px;
        }
		.el-dialog__footer{
			text-align: center;
		}
    }
</style>